import React from "react";

const Synthesizer = () => {
  return (
    <React.Fragment>
      <div className="btn__base r3c1">
        <div className="btn">
          <div className="wave">
            <div>J</div>
            <div>U</div>
            <div>U</div>
            <div>U</div>
            <div>U</div>
            <div>J</div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Synthesizer;
